import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import SanityImage from "gatsby-plugin-sanity-image"
import { rem } from "polished"
import { media } from "@sr/common"
import { RegBody, SanityImg } from "@sr/gatsby-theme-ui"

export interface CaseStudyListShape {
  caseStudy: {
    path: {
      current: string
    }
    intro: {
      intro: string
      alt: string
      snippet: string
      customerLogo: SanityImg
    }
    sidebar: {
      company: string
      headquarters: string
      industry: string
      productsUsed: [string]
    }
  }
}

const EntryRelatedCard = ({ caseStudy }: CaseStudyListShape) => {
  return (
    <EntryRelatedCardStyled>
      <div className="case-study-entry-card__container">
        <Link to={caseStudy?.path?.current || "/"}>
          <div className="case-study-entry-card__logo-container">
            {caseStudy?.intro?.customerLogo &&
            caseStudy?.intro?.customerLogo?.asset ? (
              <SanityImage
                alt={caseStudy?.intro?.customerLogo?.alt || ""}
                asset={caseStudy?.intro?.customerLogo?.asset}
                className="case-study-entry-card__company-logo"
                crop={caseStudy?.intro?.customerLogo?.crop}
                hotspot={caseStudy?.intro?.customerLogo?.hotspot}
              />
            ) : null}
          </div>
        </Link>
        <div className="case-study-entry-card__content-container">
          {caseStudy?.intro?.snippet && (
            <RegBody className="case-study-entry-card__content-intro">
              {caseStudy.intro.snippet}
            </RegBody>
          )}
          <div className="case-study-entry-card__content-inner-container">
            {caseStudy?.sidebar?.company && (
              <div className="case-study-entry-card__content-inner-text-container">
                <p className="case-study-entry-card__content-inner-title">
                  Company
                </p>
                <p className="case-study-entry-card__content-inner-value">
                  {caseStudy.sidebar.company}
                </p>
              </div>
            )}
            {caseStudy?.sidebar?.industry && (
              <div className="case-study-entry-card__content-inner-text-container">
                <p className="case-study-entry-card__content-inner-title">
                  Industry
                </p>
                <p className="case-study-entry-card__content-inner-value">
                  {caseStudy.sidebar.industry}
                </p>
              </div>
            )}
            {caseStudy?.sidebar?.headquarters && (
              <div className="case-study-entry-card__content-inner-text-container">
                <p className="case-study-entry-card__content-inner-title">
                  Headquarters
                </p>
                <p className="case-study-entry-card__content-inner-value">
                  {caseStudy.sidebar.headquarters}
                </p>
              </div>
            )}
            {caseStudy?.sidebar?.productsUsed && (
              <div className="case-study-entry-card__content-inner-text-container">
                <p className="case-study-entry-card__content-inner-title">
                  Products Used
                </p>
                <p className="case-study-entry-card__content-inner-value">
                  {caseStudy.sidebar.productsUsed.length}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="case-study-entry-card__btn-container">
        <Link to={caseStudy?.path?.current || "/"}>
          <button>Read the Case Study</button>
        </Link>
      </div>
    </EntryRelatedCardStyled>
  )
}

export default EntryRelatedCard

export const EntryRelatedCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  border-radius: ${rem(8)};
  padding: ${rem(32)} ${rem(24)} ${rem(0)} ${rem(24)};
  min-height: 100%;
  height: fit-content;
  width: ${rem(344)};

  @media ${media.midUp} {
    width: ${rem(488)};
    padding: ${rem(32)} ${rem(48)} ${rem(0)} ${rem(48)};
  }

  @media ${media.stMidUp} {
    width: ${rem(352)};
    padding: ${rem(32)} ${rem(32)} ${rem(0)} ${rem(40)};
  }

  .case-study-entry-card__logo-container {
    display: flex;
    align-items: center;
    padding: 0;
    max-width: ${rem(160)};
    height: ${rem(48)};

    .case-study-entry-card__company-logo {
      height: ${rem(48)};
      width: auto;
      object-fit: contain;
    }
  }

  .case-study-entry-card__content-container {
    display: flex;
    flex-direction: column;

    .case-study-entry-card__content-intro {
      padding: ${rem(32)} 0;
    }

    .case-study-entry-card__content-inner-container {
      display: flex;
      flex-direction: column;
      gap: ${rem(16)};

      .case-study-entry-card__content-inner-text-container {
        display: flex;
        flex-direction: column;
        gap: ${rem(8)};

        .case-study-entry-card__content-inner-title {
          color: var(--color-gray400);
          font-weight: 600;

          @media ${media.midUp} {
            font-size: ${rem(20)};
          }
        }
      }
    }
  }

  .case-study-entry-card__btn-container {
    display: flex;
    justify-content: center;
    padding: ${rem(32)} ${rem(0)} ${rem(40)};

    @media ${media.midUp} {
      padding: ${rem(32)} ${rem(0)} ${rem(48)};
    }

    button {
      background: var(--color-primary);
      color: var(--color-white);
      font-weight: 600;
      width: ${rem(222)};
      height: ${rem(40)};
      border-radius: ${rem(4)};
    }
  }
`
